<template>
  <header class="navbar navbar-static-top bs-docs-nav" id="top">
    <div class="container">
      <div class="navbar-header">
        <button
          class="navbar-toggle collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#bs-navbar"
          aria-controls="bs-navbar"
          aria-expanded="false"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <a href="/home" class="pull-left logo-header">
          <img
            class="logo-img-header"
            src="https://scdn.xidong360.com/ssy/web/images/ssy.xidong360.com.png"
          />
        </a>
      </div>
      <nav id="bs-navbar" class="collapse navbar-collapse">
        <ul class="nav navbar-nav">
          <li>
            <a href="/home">首页</a>
          </li>
          <li>
            <a href="/projects">赛事中心</a>
          </li>
          <li>
            <a href="/medias">新闻动态</a>
          </li>
          <li>
            <a href="/lives">赛事现场</a>
          </li>
          <li>
            <a href="/info">关于我们</a>
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-right">
          <li v-if="logined">
            <a href="/admin/workbench">进入赛事易</a>
          </li>
          <li v-else>
            <a href="/admin/login">登录</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {
      logined: false,
    };
  },
};
</script>
<style>
.logo-img-header {
  height: 4em;
  padding: 0.5em 0;
}
</style>